import React from "react";
import Master from "../container/master.js";
export default () => (<Master />)
